module.exports = require("@aofl/server-environment");